<template>
  <div class="box">
    <v-row>
      <v-col cols="12">
        <v-expansion-panels :value="panel" accordion multiple hover tile readonly>
          <v-expansion-panel :style="upperPanelHeight">
            <v-expansion-panel-header hide-actions>Profile</v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- eslint-disable-next-line prettier/prettier -->
              <tree-data-table
                :headers="profileHeaders" :items="profileTree" item-key="key" :height="upperTableHeight"
                @click:row="arrangeAuthTree"
                dense hide-default-footer disable-pagination fixed-header single-select>
                <template #item.typ="{ value }"> {{ value.text }} </template>
                <template #item.modDatim="{ value }"> {{ value | format('yyyy-MM-dd') }} </template>
                <template #item.assignDatim="{ value }"> {{ value | format('yyyy-MM-dd') }} </template>
              </tree-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel :style="lowerPanelHeight">
            <v-expansion-panel-header hide-actions>Authorization</v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- eslint-disable-next-line prettier/prettier -->
              <tree-data-table
                :headers="authHeaders" :items="authTree" item-key="label" :height="lowerTableHeight" :loading="loading"
                @click:expand="expandAuthNode"
                dense hide-default-footer disable-pagination fixed-header single-select>
                <template #item.descrMap="{ value }">
                  <span :style="cssDescription(value.foreColor)" small>{{ value.text }}</span>
                </template>
              </tree-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { api } from '@/api/common/instances';
import { isEmpty } from 'lodash';
import share from './searchShare.js';
export default {
  props: {
    height: {
      type: Number,
    },
    profileTree: {
      type: Array,
    },
  },
  mixins: [share],
  data() {
    return {
      // data 'panel'은 내부의 panel 모두가 디폴트로 펼쳐져서 content가 보이게 하기 위한 조치.
      panel: [0, 1],
      authHeaders: [
        { text: 'Class/Object/Auth/Filed', value: 'label', width: '25%', expandable: true, sortable: false },
        { text: 'Description', value: 'descrMap', sortable: false },
        { text: 'From', value: 'formattedVonText', sortable: false },
        { text: 'To', value: 'formattedBisText', sortable: false },
      ],
      authTree: [],
      loading: false,
    };
  },
  methods: {
    async arrangeAuthTree(profileNode, { select, selected }) {
      select(!selected);
      let param = {};
      param.svrYmdhms = profileNode.svrYmdhms;
      param.sstmId = profileNode.sstmId;
      param.mandt = profileNode.mandt;
      param.profn = profileNode.profn;
      param.aktps = profileNode.aktps;
      param.dtype = 'I'; // 최초(Init...)의 의미로 'I'를 부여한다.
      this.authTree = await this.getProfileAuthTree(param);
    },
    async expandAuthNode(node, { add }) {
      if (node._opened) return;
      let authTree = await this.getProfileAuthTree(node);
      // 현재 tree는 expand 시 추가되는 자식은 순서를 거꾸로 해주어야 한다.2021.01.11.KWShin.
      authTree = authTree.reverse();
      add(authTree);
    },
    async getProfileAuthTree(node) {
      this.loading = true;
      const { data } = await api.get('/rtrck/search/prfl-auth', {
        params: {
          svrYmdhms: node.svrYmdhms,
          sstmId: node.sstmId,
          mandt: node.mandt,
          profn: node.profn,
          aktps: node.aktps,
          oclss: node.oclss,
          objct: node.objct,
          auth: node.auth,
          dtype: node.dtype,
        },
      });
      // ProfileAuth는 dtype 속성이 'F'(노드 유형이 '필드')가 아니면 자식 노드를 갖는다.
      data.forEach(elm => {
        elm.children = [];
        if (elm.dtype != 'F') elm.leaf = false;
        else elm.leaf = true;
      });
      this.loading = false;
      return data;
    },
    cssDescription(color) {
      if (!isEmpty(color)) {
        // 원래 서버에서 '#0000FF'를 내려주는데 이는 dark 테마에서 잘 안보인다.
        if (this.$vuetify.theme.isDark) return 'color: #BBBBFF';
        return `color: ${color}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-expansion-panel-content ::v-deep .v-expansion-panel-content__wrap {
  padding: 0;
}
</style>
